import { ACT_CODE, isPROD } from '@/utils/common'
import request from './request'

const adDomain = isPROD ? 'https://tg.feidee.com' : 'https://lcts1.ssjlicai.com'

// 请求接口二次封装
export const request2 = (url: string, reqbody = {}, reqConfig = {}) => {
  return request(url, {
    actCode: ACT_CODE,
    ...reqbody
  }, {
    ...reqConfig
  })
}

/** 查询活动跑马灯数据 */
export const marquee = (params?: object) => {
  return request('/finance-common-operation-ws/api/act/marquee/v1/data', params, { loading: false })
}

/** 查询活动信息 */
export const getActConfigByCode = (actCode: string) => {
  return request('/finance-common-operation-ws/api/act/activity/v1/getActivityInfo', { actCode })
}

/** 获取wxJsSdk */
export const getWxJsSdk = (params?: object) => {
  return request(
    '/finance-common-operation-ws/api/act/wechat/v1/getWxJsSdk',
    params,
    { loading: false, showError: false/* , jweixin: true */ }
  )
}

/**
 * 查询活动信息 http://yapi.sui.work/project/58/interface/api/133073
 */
export const actConf = () => {
  return request2('/finance-common-operation-ws/api/act/activity/v1/actConf')
}

/**
 * 落地页--规则组资格校验
 * @doc http://yapi.sui.work/project/58/interface/api/133542
 */
export const ruleCheck = (params?: object) => {
  return request2('/finance-common-operation-ws/api/act/activity/v1/ruleCheck', params, {
    loading: true,
    showError: true
  })
}

/**
 * 同步规则判定触发抽奖 http://yapi.sui.work/project/58/interface/api/133115
 */
export const queryRuleDraw = (params:any) => {
  return request2('/finance-common-operation-ws/api/act/rule/v1/synRuleDrawEnhance', params)
}

/**
 * 规则组达成-触发抽奖 http://yapi.sui.work/project/58/interface/api/133087
 */
export const ruleReachDraw = (params:any) => {
  return request2('/finance-common-operation-ws/api/act/ruleReach/v1/ruleReachDraw', params, {
    errorMsg: '领奖人数火爆，别担心！<br>请稍等30分钟重试或联系客服解决'
  })
}

/**
 * 查询运营新服务货架配置信息接口V2
 * 说明：https://confluence.sui.work/pages/viewpage.action?pageId=126887175
 * @doc http://yapi.sui.work/project/58/interface/api/184554
 */
export const queryOperationNewServerShelve = (params?: object) => {
  return request2('/finance-common-operation-ws/api/operationNewServerShelve/v2/queryOperationNewServerShelve', params)
}

/**
 * 查询运营弹窗配置接口
 * @doc http://yapi.sui.work/project/58/interface/api/184086
 */
export const queryOperationPopup = (params:any) => {
  return request2('/finance-common-operation-ws/api/operationPopup/queryOperationPopup', params)
}

/**
 * 查询办卡进度
 * 说明：https://confluence.sui.work/pages/viewpage.action?pageId=130717081
 * @doc http://yapi.sui.work/project/58/interface/api/184786
 */
export const getApplySchedule = (params?: object) => {
  return request2('/finance-common-operation-ws/api/act/creditcart/v1/getApplySchedule', params)
}

/**
 * 查询金卡信息
 * @doc http://yapi.sui.work/project/58/interface/api/185342
 */
export const getGoldCardInfo = (loading = true) => {
  return request2('/finance-common-operation-ws/api/act/goldCard/v1/getGoldCardInfo', {}, {
    loading
  })
}

/**
 * 微信立减金奖品列表
 * @doc http://yapi.sui.work/project/58/interface/api/185430
 */
export const wechatRedPacketList = (params?: object) => {
  return request2('/finance-common-operation-ws/api/prize/wechat-red/v1/list', params)
}

/**
 * 商品购买接口
 * @doc http://yapi.sui.work/project/58/interface/api/185358
 */
export const productOrder = (params?: object) => {
  return request2('/finance-common-operation-ws/api/productOrder/purchase', params)
}

/**
 * 查询商品购买结果
 * @doc http://yapi.sui.work/project/58/interface/api/185326
 */
export const getPurchaseOrderStatus = (params?: object) => {
  return request2('/finance-common-operation-ws/api/productOrder/getPurchaseOrderStatus', params, {
    loading: false
  })
}

/**
 * 用户取消支付
 * @doc http://yapi.sui.work/project/58/interface/api/185326
 */
export const cancelPay = (params?: object) => {
  return request2('/finance-common-operation-ws/api/productOrder/cancelPay', params, {
    loading: false
  })
}

/**
 * 视频广告api
 * @doc https://confluence.sui.work/display/data/Video+Ad+API
 */
export const queryVideoAd = (key?: object, sys?: string, source?: string) => {
  return request(`/video-ad/api/video/quota?key=${key}&sys=${sys}&source=${source}`, {}, {
    method: 'get',
    customDomain: adDomain
  })
}

/**
 *
 * 上报广告曝光
 * @returns https://confluence.sui.work/display/data/Video+Ad+API
 */
export const showVideoAd = (params?: object) => {
  return request('/video-ad/api/video/show', params, {
    method: 'post',
    customDomain: adDomain
  })
}

/**
 *
 * 上报广告完成
 * @returns https://confluence.sui.work/display/data/Video+Ad+API
 */
export const doneVideoAd = (params?: object) => {
  return request('/video-ad/api/video/done', params, {
    method: 'post',
    customDomain: adDomain
  })
}
